import { InfoIcon } from '../../../../lib/icons/InfoIcon';
import Notification, { NotificationType } from '../Notification/Notification';
import { useApplication } from '../../../../lib/context/ApplicationConfigurationContext';
import { replacePlaceholder } from '../../../../lib/utils/placeholders/replacePlaceholder';
import styles from './PickerForm.module.scss';
import { useDevice } from '../../../../lib/hooks/device';
import { isApiTrainingTeam } from './PickerForm.utils';
import { PickerFormItem } from './PickerFormTypes';
import { pickerFormIds } from '../../../../lib/tests/testIds';

type TeamSizeWarningProps = {
  message: string;
  totalMembers?: number;
  selectedItems: PickerFormItem[];
  onClickHandler: () => void;
};

const TeamSizeWarning = ({ message, totalMembers, selectedItems, onClickHandler }: TeamSizeWarningProps) => {
  const { config } = useApplication();
  const device = useDevice();

  const verifiedTotalMembers =
    totalMembers ??
    selectedItems.map(item => (isApiTrainingTeam(item) ? item.totalMembers ?? 0 : 1)).reduce((a, b) => a + b, 0);

  const variantProps = (() => {
    if (verifiedTotalMembers > (config?.teamSizeWarningThreshold ?? 50)) {
      return { type: NotificationType.Warning, ariaRole: 'alert' as const };
    }

    return { type: NotificationType.Info, ariaRole: 'presentation' as const };
  })();

  return (
    <Notification
      wrapperClass={styles.teamSizeWarningWrapper}
      content={
        <span className={styles.teamSizeWarningText}>
          <InfoIcon className={styles.infoIcon} />
          {replacePlaceholder({ totalMembers: verifiedTotalMembers }, message)}
        </span>
      }
      open
      showCloseButton={device !== 'desktop'}
      onClickHandler={onClickHandler}
      data-testid={pickerFormIds.teamSizeWarning}
      {...variantProps}
    />
  );
};

export default TeamSizeWarning;
